import axios from 'axios'

import {
    CustomerEmailExistsUrl,
    BusinessInformationsUrl,
    CheckPostalCodeUrl,
} from '../constants/IntegrationConstants'

import {
    businessCustomerType,
} from '../constants/GeneralConstants'

function getAxiosInstance(baseURL, apiKey) {
    return axios.create({
        baseURL: baseURL,
        timeout: 20000,
        withCredentials: false,
        headers: { 'X-ApiKey': apiKey }
    })
}

export function checkCustomerEmailExists(email, customerType, baseURL, apiKey) {

    try {
        const instance = getAxiosInstance( baseURL, apiKey )

        let customerTypeParameter = 1 // default customertype is person

        if(customerType === businessCustomerType) {
            customerTypeParameter = 2
        }

        const emailQueryParameter = '?type=' + customerTypeParameter
        const queryUrl = CustomerEmailExistsUrl + email + emailQueryParameter

        return instance.get(queryUrl)
    } catch (error) {
        console.debug({error})
        return error
    }
}

export function getBusinessInformation(id, baseURL, apiKey) {
    try {
        const instance = getAxiosInstance(baseURL, apiKey)
        return instance.get(BusinessInformationsUrl + id)
    } catch (error) {
        console.log(error)
        return error
    }
}

export function checkValidPostalcodeArea(postalCode, baseURL, apiKey) {
    try {
        const instance = getAxiosInstance(baseURL, apiKey)
        return instance.get(CheckPostalCodeUrl + postalCode)
    } catch (error) {
        console.log(error)
        return error
    }
}
